import { render, staticRenderFns } from "./product-filter-group.vue?vue&type=template&id=4592e7a9&"
import script from "./product-filter-group.vue?vue&type=script&lang=js&"
export * from "./product-filter-group.vue?vue&type=script&lang=js&"
import style0 from "./product-filter-group.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports